<app-mat-spinner-overlay [overlay]="true" *ngIf="this.loading > 0">
</app-mat-spinner-overlay>
<div *ngIf = "usuario && usuario.sucesso" class="panel panel-default form-filtrar form-default" [ngClass]="usuario.retorno.aparencia">
    <h1>Seleção de Frota</h1>
    <form (ngSubmit)="onSubmit()" #filtroForm="ngForm" class="panel-body">
        <div class="input-group">
            <label class="center-block">
                Pesquisar por
            </label>
            <div class="input-group"></div>
            <mat-select [(ngModel)]="filtro.coluna" name="coluna" class="form-control dropdown-filtro"
                matTooltip="Pesquise a Frota por" style="min-width: 100px; max-width: 200px;">
                <mat-option value="1">Por Código</mat-option>
                <mat-option value="2">Por Nome Fantasia</mat-option>
                <mat-option value="3">Por Razão Social</mat-option>
                <mat-option value="4">Por Cidade</mat-option>
                <mat-option value="5">Por UF</mat-option>
            </mat-select>
            <mat-select [(ngModel)]="filtro.operador" name="operador" class="form-control dropdown-filtro"
                style="min-width: 100px; max-width: 200px; margin-left: 10px;">
                <mat-option [value]=1>Igual a</mat-option>
                <mat-option [value]=2>Maior que</mat-option>
                <mat-option [value]=3>Menor que</mat-option>
                <mat-option [value]=4>Contendo</mat-option>
                <mat-option [value]=5>Iniciando por</mat-option>
            </mat-select>
            <input type="text" #search required [(ngModel)]="filtro.parametro" name="parametro" id="parametro"
                class="form-control"
                style="margin-left: 10px; min-width: 200px;" matTooltip="Preecha para a pesquisa da Frota"
                #parametro="ngModel" />
            <div [hidden]="parametro.valid || parametro.pristine" style="margin-left: 10px; padding-top: 10px; color: #7d0c12">
                <span>Campo é obrigatório</span>
            </div>
            <button type="submit" 
                mat-icon-button style="margin-left: 10px"
                 matTooltip="Pesquise a Frota"
                [disabled]="!filtroForm.form.valid">
                    <mat-icon aria-hidden="false" aria-label="Pesquise a Frota" fontIcon="search"></mat-icon>
            </button>
            <button type="button" mat-icon-button style="margin-left: 10px" matTooltip="Limpe o resultado da pesquisa de Frota"
                (click)="limpaFiltro()">
                <mat-icon aria-hidden="false" aria-label="Limpe o resultado da pesquisa de Frota" fontIcon="delete">
                </mat-icon>
            </button>
            <button type="button" mat-icon-button style="margin-left: 10px" matTooltip="Fechar" (click)="fechar()">
                <mat-icon aria-hidden="false" aria-label="Fechar" fontIcon="close">
                </mat-icon>
            </button>
        </div>
    </form>
    <div>
        <mat-form-field class="pesquisa-filtro">
            <input matInput #txtVal (keyup)="applyFilter(txtVal.value)" placeholder="Digite para pesquisar Frota ...">
        </mat-form-field>
    </div>
    <div class="lista-container">
        <mat-table [dataSource]="dataSource" matSort>

            <!-- Código Frota Column -->
            <ng-container matColumnDef="codigo">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Código </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.codigo}} </mat-cell>
            </ng-container>

            <!-- Nome Column -->
            <ng-container matColumnDef="nomeReduzido">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Fantasia </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.nomeReduzido}} </mat-cell>
            </ng-container>

            <!-- Nome Column -->
            <ng-container matColumnDef="descricao">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Razão Social </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.descricao}} </mat-cell>
            </ng-container>

            <!-- Cidade Column -->
            <ng-container matColumnDef="municipio">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Cidade </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.municipio}} </mat-cell>
            </ng-container>

            <!-- UF Column -->
            <ng-container matColumnDef="estado">
                <mat-header-cell *matHeaderCellDef mat-sort-header> UF </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{row.estado}} </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="getRecord(row)">
            </mat-row>

        </mat-table>

        <mat-paginator #paginator class="filter-paginator" [pageSizeOptions]="[5, 10, 20, 50, 100, 500, 1000, 9999]"
            [pageSize]="5" aria-label="Seleciona a página">
        </mat-paginator>
    </div>
</div>